export const ZZZShiyuCharData = [
  {
    char: 'anby-demara',
    name: 'Anby',
    rarity: '4*',
    current_app_rate: 1.93,
    prev_app_rate: 3.57,
    current_avg_score: 190,
    prev_avg_score: 178,
    app_free: 0.67,
    round_free: 194,
    app_dupes: 0.62,
    round_dupes: 156
  },
  {
    char: 'anby-demara-soldier-0',
    name: 'Anby S0',
    rarity: 'Limited 5*',
    current_app_rate: 34.18,
    prev_app_rate: 42.45,
    current_avg_score: 144,
    prev_avg_score: 131,
    app_free: 4.95,
    round_free: 174,
    app_dupes: 8.42,
    round_dupes: 110
  },
  {
    char: 'anton',
    name: 'Anton',
    rarity: '4*',
    current_app_rate: 0.25,
    prev_app_rate: 0.38,
    current_avg_score: 600,
    prev_avg_score: 600,
    app_free: 0.17,
    round_free: 600,
    app_dupes: 0.02,
    round_dupes: 600
  },
  {
    char: 'astra-yao',
    name: 'Astra Yao',
    rarity: 'Limited 5*',
    current_app_rate: 82.66,
    prev_app_rate: 81.58,
    current_avg_score: 112,
    prev_avg_score: 116,
    app_free: 12.79,
    round_free: 137,
    app_dupes: 27.07,
    round_dupes: 80
  },
  {
    char: 'ben',
    name: 'Ben',
    rarity: '4*',
    current_app_rate: 0.21,
    prev_app_rate: 0.1,
    current_avg_score: 600,
    prev_avg_score: 600,
    app_free: 0.04,
    round_free: 600,
    app_dupes: 0.02,
    round_dupes: 600
  },
  {
    char: 'billy-kid',
    name: 'Billy',
    rarity: '4*',
    current_app_rate: 0.23,
    prev_app_rate: 0.28,
    current_avg_score: 600,
    prev_avg_score: 600,
    app_free: 0.1,
    round_free: 600,
    app_dupes: 0.02,
    round_dupes: 600
  },
  {
    char: 'burnice',
    name: 'Burnice',
    rarity: 'Limited 5*',
    current_app_rate: 26.26,
    prev_app_rate: 23.34,
    current_avg_score: 135,
    prev_avg_score: 121,
    app_free: 4.62,
    round_free: 153,
    app_dupes: 8.17,
    round_dupes: 107
  },
  {
    char: 'caesar',
    name: 'Caesar',
    rarity: 'Limited 5*',
    current_app_rate: 23.95,
    prev_app_rate: 27.03,
    current_avg_score: 155,
    prev_avg_score: 140,
    app_free: 2.6,
    round_free: 189,
    app_dupes: 9.13,
    round_dupes: 112
  },
  {
    char: 'corin',
    name: 'Corin',
    rarity: '4*',
    current_app_rate: 0.27,
    prev_app_rate: 0.48,
    current_avg_score: 600,
    prev_avg_score: 600,
    app_free: 0.02,
    round_free: 600,
    app_dupes: 0.04,
    round_dupes: 600
  },
  {
    char: 'ellen',
    name: 'Ellen',
    rarity: 'Limited 5*',
    current_app_rate: 1.85,
    prev_app_rate: 5.45,
    current_avg_score: 186,
    prev_avg_score: 182,
    app_free: 0.08,
    round_free: 600,
    app_dupes: 1.16,
    round_dupes: 141
  },
  {
    char: 'evelyn',
    name: 'Evelyn',
    rarity: 'Limited 5*',
    current_app_rate: 14.57,
    prev_app_rate: 10.9,
    current_avg_score: 141,
    prev_avg_score: 135,
    app_free: 2.02,
    round_free: 173,
    app_dupes: 3.78,
    round_dupes: 104
  },
  {
    char: 'grace-howard',
    name: 'Grace',
    rarity: 'Standard 5*',
    current_app_rate: 2.35,
    prev_app_rate: 2.39,
    current_avg_score: 155,
    prev_avg_score: 161,
    app_free: 0.54,
    round_free: 156,
    app_dupes: 0.71,
    round_dupes: 136
  },
  {
    char: 'harumasa',
    name: 'Harumasa',
    rarity: 'Limited 5*',
    current_app_rate: 12.1,
    prev_app_rate: 19.03,
    current_avg_score: 176,
    prev_avg_score: 146,
    app_free: 2.79,
    round_free: 190,
    app_dupes: 4.07,
    round_dupes: 143
  },
  {
    char: 'jane-doe',
    name: 'Jane Doe',
    rarity: 'Limited 5*',
    current_app_rate: 14.97,
    prev_app_rate: 4.54,
    current_avg_score: 168,
    prev_avg_score: 179,
    app_free: 2.81,
    round_free: 175,
    app_dupes: 4.95,
    round_dupes: 127
  },
  {
    char: 'koleda',
    name: 'Koleda',
    rarity: 'Standard 5*',
    current_app_rate: 2.95,
    prev_app_rate: 2.24,
    current_avg_score: 164,
    prev_avg_score: 157,
    app_free: 0.64,
    round_free: 203,
    app_dupes: 0.56,
    round_dupes: 116
  },
  {
    char: 'lighter',
    name: 'Lighter',
    rarity: 'Limited 5*',
    current_app_rate: 7.42,
    prev_app_rate: 8.31,
    current_avg_score: 128,
    prev_avg_score: 124,
    app_free: 0.81,
    round_free: 157,
    app_dupes: 2.62,
    round_dupes: 100
  },
  {
    char: 'lucy',
    name: 'Lucy',
    rarity: '4*',
    current_app_rate: 18.69,
    prev_app_rate: 19.21,
    current_avg_score: 137,
    prev_avg_score: 126,
    app_free: 2.64,
    round_free: 170,
    app_dupes: 5.86,
    round_dupes: 101
  },
  {
    char: 'lycaon',
    name: 'Lycaon',
    rarity: 'Standard 5*',
    current_app_rate: 10.79,
    prev_app_rate: 18.27,
    current_avg_score: 125,
    prev_avg_score: 130,
    app_free: 0.62,
    round_free: 155,
    app_dupes: 5.22,
    round_dupes: 97
  },
  {
    char: 'miyabi',
    name: 'Miyabi',
    rarity: 'Limited 5*',
    current_app_rate: 77.17,
    prev_app_rate: 88.66,
    current_avg_score: 97,
    prev_avg_score: 111,
    app_free: 3.72,
    round_free: 115,
    app_dupes: 33.45,
    round_dupes: 77
  },
  {
    char: 'nekomata',
    name: 'Nekomata',
    rarity: 'Standard 5*',
    current_app_rate: 0.4,
    prev_app_rate: 0.41,
    current_avg_score: 600,
    prev_avg_score: 600,
    app_free: 0.15,
    round_free: 600,
    app_dupes: 0.12,
    round_dupes: 600
  },
  {
    char: 'nicole-demara',
    name: 'Nicole',
    rarity: '4*',
    current_app_rate: 42,
    prev_app_rate: 37.53,
    current_avg_score: 128,
    prev_avg_score: 130,
    app_free: 8.96,
    round_free: 147,
    app_dupes: 13.16,
    round_dupes: 94
  },
  {
    char: 'piper',
    name: 'Piper',
    rarity: '4*',
    current_app_rate: 3.08,
    prev_app_rate: 2.06,
    current_avg_score: 163,
    prev_avg_score: 138,
    app_free: 0.79,
    round_free: 175,
    app_dupes: 0.71,
    round_dupes: 140
  },
  {
    char: 'pulchra',
    name: 'Pulchra',
    rarity: '4*',
    current_app_rate: 6.32,
    prev_app_rate: 8.56,
    current_avg_score: 174,
    prev_avg_score: 160,
    app_free: 1.06,
    round_free: 210,
    app_dupes: 1.46,
    round_dupes: 132
  },
  {
    char: 'qingyi',
    name: 'Qingyi',
    rarity: 'Limited 5*',
    current_app_rate: 23.2,
    prev_app_rate: 30.47,
    current_avg_score: 164,
    prev_avg_score: 145,
    app_free: 6.05,
    round_free: 170,
    app_dupes: 7.26,
    round_dupes: 135
  },
  {
    char: 'rina',
    name: 'Rina',
    rarity: 'Standard 5*',
    current_app_rate: 21.12,
    prev_app_rate: 26.45,
    current_avg_score: 145,
    prev_avg_score: 136,
    app_free: 4.1,
    round_free: 166,
    app_dupes: 5.99,
    round_dupes: 111
  },
  {
    char: 'seth',
    name: 'Seth',
    rarity: '4*',
    current_app_rate: 3.72,
    prev_app_rate: 3.57,
    current_avg_score: 196,
    prev_avg_score: 169,
    app_free: 0.79,
    round_free: 201,
    app_dupes: 1.23,
    round_dupes: 151
  },
  {
    char: 'soldier-11',
    name: 'Soldier 11',
    rarity: 'Standard 5*',
    current_app_rate: 1.16,
    prev_app_rate: 0.64,
    current_avg_score: 177,
    prev_avg_score: 194,
    app_free: 0.31,
    round_free: 600,
    app_dupes: 0.48,
    round_dupes: 139
  },
  {
    char: 'soukaku',
    name: 'Soukaku',
    rarity: '4*',
    current_app_rate: 16.28,
    prev_app_rate: 21.96,
    current_avg_score: 118,
    prev_avg_score: 129,
    app_free: 0.64,
    round_free: 136,
    app_dupes: 8.21,
    round_dupes: 93
  },
  {
    char: 'trigger',
    name: 'Trigger',
    rarity: 'Limited 5*',
    current_app_rate: 42.95,
    prev_app_rate: 44.82,
    current_avg_score: 139,
    prev_avg_score: 126,
    app_free: 5.61,
    round_free: 167,
    app_dupes: 12.25,
    round_dupes: 103
  },
  {
    char: 'vivian',
    name: 'Vivian',
    rarity: 'Limited 5*',
    current_app_rate: 45.03,
    prev_app_rate: 45.03,
    current_avg_score: 105,
    prev_avg_score: 105,
    app_free: 5.84,
    round_free: 125,
    app_dupes: 15.76,
    round_dupes: 80
  },
  {
    char: 'yanagi',
    name: 'Yanagi',
    rarity: 'Limited 5*',
    current_app_rate: 43.26,
    prev_app_rate: 48.71,
    current_avg_score: 120,
    prev_avg_score: 120,
    app_free: 7.3,
    round_free: 144,
    app_dupes: 13.26,
    round_dupes: 86
  },
  {
    char: 'zhu-yuan',
    name: 'Zhu Yuan',
    rarity: 'Limited 5*',
    current_app_rate: 17.36,
    prev_app_rate: 14.52,
    current_avg_score: 145,
    prev_avg_score: 149,
    app_free: 5.47,
    round_free: 150,
    app_dupes: 5.05,
    round_dupes: 118
  }
];
